module.exports = __webpack_public_path__ + "static/media/dashboard.9fac4522.svg";